<template>
    <ul>
        <li v-for="item in items.slice(0,3)" :key="item.Auteur+item.Titre">{{item.Auteur}}<template v-if="item.Auteur && item.Titre"> - </template>{{item.Titre}}</li>
    </ul>
</template>

<script>
export default {
    props: {
        'oma': {type: Object, required: true},
        'channel': {type: String, required: true},
    },
    data: () => ({
        itemsDirect: [], /* list of dict */
        itemsReplay: [],
    }),
    created: function () {
        const _this = this;
        this.oma.ows.handler(this.channel,     (data) => {_this.itemsDirect = _this.update(data)})
        this.oma.ows.handler('R'+this.channel, (data) => {_this.itemsReplay = _this.update(data)})
    },
    methods: {
        update: function (data) {
            var l = [];
            var newitem = null;
            for (var i in data) {
                if ('M' in data[i] || 'C' in data[i] ) { continue; }
                else if ('A' in data[i]) {
                    newitem = {Auteur: data[i]['A']};
                }
                else if ('T' in data[i]) {
					if (newitem == null) {
						newitem = {Auteur: ''};
					}
                    newitem.Titre = data[i]['T'];
                    l.push(newitem);
					newitem = null;
                }
            }
            return l;
        },
    },
    computed: {
        items: function() {
			if (this.oma.player.TYPES.isReplay)
				return this.itemsReplay
			else if (this.oma.player.TYPES.isDirect || this.oma.player.TYPES.isNone)
				return this.itemsDirect
			else
				return []
        },
    }
}
</script>

<style scoped>
    ul {
        margin: 5px;
        padding-left: 15px;
    }
    ul li:first-child {
        list-style-type: circle;
    }
</style>
